import React from 'react';
import { IconProps } from '../../types/icon';

const DocxIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/DocxIcon.png"
      alt="Word Document"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default DocxIcon;
